import { createInput, createInputFile, createFormActions, createSelection } from ":ui/form";

export function createAttendnceInputs() {
  const FullnameAr = createInput(null, { required: true });
  const FullnameEn = createInput(null, { required: true });
  const File = createInputFile(null, { required: true });
  const AgreedAttendace = createSelection(false, { required: true });
  const AgreedTerms = createSelection(false, { required: true });
  const AgreedPhoto = createSelection(false, { required: true });

  const Actions = createFormActions({ FullnameAr, FullnameEn, File, AgreedAttendace, AgreedTerms, AgreedPhoto });
  return {
    Actions,
    FullnameAr,
    FullnameEn,
    File,
    AgreedAttendace,
    AgreedTerms,
    AgreedPhoto,
  };
}
